'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = _getEntry;

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getEntry(resource) {
    if (!resource) return null;

    if (resource[_constants.ENTRY]) return resource[_constants.ENTRY];

    if ((0, _typeof3.default)(resource.state) === 'symbol') return resource;

    return null;
}